var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmarkBook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#505050",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M1 18V3.125C1 1.951 1.951 1 3.125 1h14.238c.352 0 .637.285.637.638V15.57"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#505050",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M5.25 1v8.5l2.657-1.7 2.656 1.7V1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#505050",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M3.125 15.875H18M3.125 20.125H18"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#505050",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M3.125 20.125a2.125 2.125 0 0 1 0-4.25"
})));
export default SvgBookmarkBook;